import { render, staticRenderFns } from "./VendorDidsList.vue?vue&type=template&id=361439da&scoped=true&"
import script from "./VendorDidsList.vue?vue&type=script&lang=js&"
export * from "./VendorDidsList.vue?vue&type=script&lang=js&"
import style0 from "./VendorDidsList.vue?vue&type=style&index=0&id=361439da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361439da",
  null
  
)

component.options.__file = "VendorDidsList.vue"
export default component.exports